var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section customer-form" },
    [
      _c(
        "div",
        { staticClass: "inner-row" },
        [
          _c(
            "el-form",
            {
              staticClass: "form-item-350",
              attrs: {
                disabled: _vm.readonly,
                inline: true,
                "label-width": "80px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "margin-Right50",
                  attrs: { label: _vm.$t("SeaExport.CustomerLevel") }
                },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "customerTypeId",
                      "allow-create": false,
                      filterable: "",
                      cache: false,
                      "default-value": _vm.form.customerTypeId,
                      clearable: "",
                      "tag-name": _vm.isZh ? "chineseName" : "englishName",
                      "tag-value": "typeId",
                      "static-options": _vm.customerTypeList
                    },
                    on: { parentCallBack: _vm.customerTypeIdFunc }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Partners.departmentBelonging") } },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex", width: "600px" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "220px" },
                          attrs: {
                            no: "ownerDepartment",
                            value: _vm.form.ownerDepartment || "",
                            disabled: _vm.departmentList.length === 0
                          },
                          on: { input: _vm.onDepartmentInput }
                        },
                        _vm._l(_vm.departmentList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.departmentId
                            }
                          })
                        }),
                        1
                      ),
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { no: "peer" },
                          model: {
                            value: _vm.form.peer,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "peer", $$v)
                            },
                            expression: "form.peer"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Partners.peers")))]
                      ),
                      _vm.showCompanyUser
                        ? _c(
                            "span",
                            { staticStyle: { "margin-right": "10px" } },
                            [_vm._v(_vm._s(_vm.$t("Payment.solicitationType")))]
                          )
                        : _vm._e(),
                      _vm.showCompanyUser
                        ? _c(
                            "el-checkbox",
                            {
                              staticStyle: { "margin-right": "10px" },
                              attrs: {
                                disabled: _vm.isSalesForSzfs,
                                no: "seftCanvass"
                              },
                              model: {
                                value: _vm.form.seftCanvass,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "seftCanvass", $$v)
                                },
                                expression: "form.seftCanvass"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Partners.customerSpace3")))]
                          )
                        : _vm._e(),
                      _vm.showCompanyUser && !_vm.isSalesForSzfs
                        ? _c(
                            "el-checkbox",
                            {
                              staticStyle: { "margin-right": "10px" },
                              attrs: { no: "designated" },
                              model: {
                                value: _vm.form.designated,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "designated", $$v)
                                },
                                expression: "form.designated"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Partners.customerSpace2")))]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              _c("br"),
              !_vm.showCompanyUser
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "margin-Right50",
                      attrs: { label: _vm.$t("Payment.solicitationType") }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { "margin-right": "10px" },
                              attrs: {
                                disabled: _vm.isSalesForSzfs,
                                no: "seftCanvass"
                              },
                              model: {
                                value: _vm.form.seftCanvass,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "seftCanvass", $$v)
                                },
                                expression: "form.seftCanvass"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Partners.customerSpace3")))]
                          ),
                          !_vm.isSalesForSzfs
                            ? _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-right": "10px" },
                                  attrs: { no: "designated" },
                                  model: {
                                    value: _vm.form.designated,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "designated", $$v)
                                    },
                                    expression: "form.designated"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("Partners.customerSpace2"))
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.form.seftCanvass
                            ? _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "65px"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("Payment.sales")))]
                              )
                            : _vm._e(),
                          _vm.form.seftCanvass
                            ? _c("cargo-user-select", {
                                attrs: {
                                  no: "sales",
                                  "method-params": {
                                    category: "role",
                                    shape: "sales"
                                  },
                                  "default-value": _vm.form.sales || ""
                                },
                                on: {
                                  change: function(p) {
                                    _vm.form.sales = p.value || 0
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { staticClass: "form-item-430", attrs: { "label-width": "0" } },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { width: "80px" },
                          attrs: { no: "iTraceService" },
                          model: {
                            value: _vm.form.iTraceService,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "iTraceService", $$v)
                            },
                            expression: "form.iTraceService"
                          }
                        },
                        [_vm._v("i-trace")]
                      ),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            width: "100px",
                            display: "inline-block"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Partners.introductionDate")))]
                      ),
                      _c("el-date-picker", {
                        attrs: {
                          no: "iTraceStartDate",
                          disabled: !_vm.form.iTraceService,
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.form.iTraceStartDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "iTraceStartDate", $$v)
                          },
                          expression: "form.iTraceStartDate"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_SourceOfClient") } },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "customerSourceUuid",
                      "select-type":
                        _vm.selectTypeNames.basic_data_CustomerSource,
                      filterable: "",
                      "tag-value": "uuid",
                      "default-value": _vm.form.customerSourceUuid || ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.customerSourceUuid = p.uuid
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "grid-view" }, [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "flex-direction": "row",
              height: "100%"
            }
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      !_vm.isSalesForSzfs &&
                      (_vm.form.designated || _vm.showCompanyUser),
                    expression:
                      "!isSalesForSzfs && (form.designated || showCompanyUser)"
                  }
                ],
                staticClass: "main-content",
                staticStyle: { flex: "1", "margin-right": "5px" }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("Partners.destinationNominatedAgent")))
                ]),
                _c(
                  "div",
                  {
                    staticClass: "operations",
                    staticStyle: { "margin-bottom": "5px" }
                  },
                  [
                    _c("div", { staticClass: "triggers" }, [
                      _c(
                        "div",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "showEditDialog",
                                disabled: _vm.readonly,
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.showEditDialog(true)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "showEditDialog",
                                disabled: _vm.readonly,
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.showEditDialog(false)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "remove",
                                disabled: _vm.readonly,
                                type: "danger"
                              },
                              on: { click: _vm.remove }
                            },
                            [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "grid-wrapper" },
                  [
                    _c("cargo-ag-grid", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        "grid-options": _vm.gridOptions,
                        "side-bar": _vm.sideBarDefs,
                        "column-defs": _vm.columnDefs,
                        "row-data": _vm.finalRowData
                      },
                      on: {
                        gridReady: function(params) {
                          return (_vm.gridApi = params.api)
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showCompanyUser,
                    expression: "showCompanyUser"
                  }
                ],
                staticClass: "main-content",
                staticStyle: { flex: "1", "margin-left": "5px" }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(
                    _vm._s(_vm.$t("Partners.theCorrespondingServicePartners"))
                  )
                ]),
                _c("company-user-container", {
                  ref: "companyUserContainer",
                  attrs: { action: _vm.action }
                })
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          {
            staticStyle: {
              width: "50%",
              "padding-right": "5px",
              "padding-top": "5px"
            }
          },
          [
            _c("span", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CustomerAssociatedFactory")))
            ]),
            _c(
              "div",
              {
                staticClass: "operations",
                staticStyle: { "margin-bottom": "5px" }
              },
              [
                _c("div", { staticClass: "triggers" }, [
                  _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "factorySignAdd",
                            disabled: _vm.readonly,
                            type: "primary"
                          },
                          on: { click: _vm.factorySignAddDialog }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "factorySignRemove",
                            disabled: _vm.readonly,
                            type: "danger"
                          },
                          on: { click: _vm.factorySignAddRemove }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                      )
                    ],
                    1
                  )
                ])
              ]
            ),
            _c(
              "div",
              { staticClass: "grid-wrapper" },
              [
                _c("cargo-ag-grid", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    "grid-options": _vm.factorySign.gridOptions,
                    "side-bar": _vm.sideBarDefs,
                    "column-defs": _vm.factorySign.columnDefs,
                    "row-data": _vm.companyFactorySigns
                  },
                  on: {
                    gridReady: function(params) {
                      return (_vm.factorySign.gridApi = params.api)
                    }
                  }
                })
              ],
              1
            )
          ]
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "customer-form",
          attrs: {
            visible: _vm.editDialog.visible,
            title: _vm.editDialog.title,
            width: "400px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "100px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.portOfDestination") } },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "260px" },
                        attrs: {
                          no: "destinationPort",
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          filterable: "",
                          "callback-params": { key: "destinationPort" },
                          "callback-method-type": "value",
                          "default-value": _vm.editDialog.form.destinationPort
                        },
                        on: { parentCallBack: _vm.selectCargoItemOfDialog }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.isDefault") } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { no: "defaultAgent" },
                          on: { change: _vm.onDefaultChange },
                          model: {
                            value: _vm.editDialog.form.defaultAgent,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "defaultAgent", $$v)
                            },
                            expression: "editDialog.form.defaultAgent"
                          }
                        },
                        [
                          _c(
                            "el-radio",
                            { attrs: { no: "yes", label: true } },
                            [_vm._v(_vm._s(_vm.$t("Message.Yes")))]
                          ),
                          _c(
                            "el-radio",
                            { attrs: { no: "no", label: false } },
                            [_vm._v(_vm._s(_vm.$t("Message.No")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("queryJob.nominatedAgent") } },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "260px" },
                        attrs: {
                          no: "destinationAgentId",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": { overseaAgent: true, active: true },
                          "default-value":
                            _vm.editDialog.form.destinationAgentId || "",
                          filterable: ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.editDialog.form.destinationAgentId =
                              p.value || 0
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.remarks") } },
                    [
                      _c("el-input", {
                        attrs: { no: "remarks" },
                        model: {
                          value: _vm.editDialog.form.remarks,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "remarks", $$v)
                          },
                          expression: "editDialog.form.remarks"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "save", type: "primary" },
                  on: { click: _vm.saveSub }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.editDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "customer-form",
          attrs: {
            visible: _vm.factorySign.addDialog.visible,
            title: _vm.factorySign.addDialog.title,
            width: "400px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.factorySign.addDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "100px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.Factory") } },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "260px" },
                        attrs: {
                          no: "destinationAgentId",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": { factorySign: true, active: true },
                          filterable: "",
                          multiple: true,
                          "default-multiple-value":
                            _vm.factorySign.addDialog.factorySignValue
                        },
                        on: {
                          parentCallBack: function(item) {
                            return (_vm.factorySign.addDialog.factorySignValue =
                              item.value)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "save", type: "primary" },
                  on: { click: _vm.saveFactorySign }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.factorySign.addDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }